/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect } from "react";
import SiteRoutes from "./components/SiteRoutes";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import NavBar from "./components/layout/NavBar/NavBar";
import Footer from "./components/layout/Footer/Footer";
import { AuthProvider } from "./services/auth/AuthContext";
import ScrollToTop from "./components/ScrollToTop";
import Config from "./Config";
import Maintenance from "./components/features/Maintenance/Maintenance";
import "./styles/variables.css";

function App() {
  // Reset any body background styles that might have been set by components
  useEffect(() => {
    return () => {
      // Clean up any background styles
      document.body.style.backgroundImage = '';
      document.body.style.backgroundPosition = '';
      document.body.style.backgroundSize = '';
      document.body.style.backgroundRepeat = '';
      document.body.style.backgroundAttachment = '';

      // Clean up any body classes
      document.body.classList.remove('homepage-body');
      document.body.classList.remove('maintenance-body');
    };
  }, []);

  // Check if the site is in maintenance mode
  const isMaintenanceMode = Config.maintenanceMode;

  return (
    <AuthProvider>
      <div className="page-container">
        <ScrollToTop />
        <NavBar />
        <main>
          {isMaintenanceMode ? <Maintenance /> : <SiteRoutes />}
        </main>
        <Footer />
      </div>
    </AuthProvider>
  );
}

export default App;
